export const permissions = (state) => state.permissions
export const allPermissions = (state) => state.all

